import Sidebar from './sidebar';
import MainLayout from '@/components/layouts';

export default function MessagesLayout({children}: { children: React.ReactNode }) {
    const breadcrumb = [{ name: 'Messages', href: '#' }];

    return (
        <MainLayout rightSidebar={false} nopad breadcrumb={breadcrumb}>
            <div className="flex h-[calc(100vh-65px)]">
                <Sidebar />

                {children}
            </div>
        </MainLayout>
    );
}